import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Panel, Btn, Field, inputCls } from "./AdminUI";
import { Plus, Pencil, Trash2, Search } from "lucide-react";

const empty = { name: "", enrollment_no: "", chamber_no: "", phone: "", specialization: "" };

export default function ManageMembers() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(null);
  const [q, setQ] = useState("");

  const load = () => api.get("/members").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (form.id) await api.put(`/members/${form.id}`, form);
    else await api.post("/members", form);
    setForm(null); load();
  };
  const del = async (id) => { if (window.confirm("Remove this member?")) { await api.delete(`/members/${id}`); load(); } };

  const filtered = list.filter((m) => !q || [m.name, m.enrollment_no, m.specialization].join(" ").toLowerCase().includes(q.toLowerCase()));

  return (
    <Panel title="Manage Bar Directory" actions={<Btn onClick={() => setForm({ ...empty })} data-testid="add-member"><Plus size={15} /> Add Member</Btn>}>
      {form && (
        <form onSubmit={save} className="mb-6 p-4 rounded-lg bg-[#FAF7F0] border border-[#E5DECF] space-y-3" data-testid="member-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Advocate Name"><input className={inputCls} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="member-name" /></Field>
            <Field label="Enrolment No."><input className={inputCls} value={form.enrollment_no} onChange={(e) => setForm({ ...form, enrollment_no: e.target.value })} /></Field>
            <Field label="Chamber No."><input className={inputCls} value={form.chamber_no} onChange={(e) => setForm({ ...form, chamber_no: e.target.value })} /></Field>
            <Field label="Phone"><input className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
            <Field label="Specialization"><input className={inputCls} value={form.specialization} onChange={(e) => setForm({ ...form, specialization: e.target.value })} /></Field>
          </div>
          <div className="flex gap-2"><Btn type="submit" data-testid="member-save">Save</Btn><Btn type="button" variant="outline" onClick={() => setForm(null)}>Cancel</Btn></div>
        </form>
      )}
      <div className="relative mb-4 w-72 max-w-full">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A6320]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members…" className={`${inputCls} pl-9`} />
      </div>
      <div className="space-y-2">
        {filtered.map((m) => (
          <div key={m.id} className="flex items-center justify-between gap-3 border border-[#F0E9DA] rounded-lg px-4 py-3" data-testid={`admin-member-${m.id}`}>
            <div><div className="font-medium text-[#2a2422]">{m.name}</div><div className="text-xs text-[#5A6270]">{m.enrollment_no} · {m.specialization} · {m.phone}</div></div>
            <div className="flex gap-2">
              <Btn variant="outline" onClick={() => setForm(m)}><Pencil size={14} /></Btn>
              <Btn variant="danger" onClick={() => del(m.id)} data-testid={`delete-member-${m.id}`}><Trash2 size={14} /></Btn>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
}
